/**
 * A pin on the map (ADR-093): degrees on the wire, six decimals; integer
 * micro-degrees where it is kept, so a pin read back is the pin saved.
 */
/** Degrees to micro-degrees, rounded to the sixth decimal (about 11 cm). */
export function microDegrees(degrees) {
    return Math.round(degrees * 1_000_000);
}
/** Micro-degrees back to degrees with six decimals. */
export function degreesOf(micro) {
    return micro / 1_000_000;
}
/** A pin both of whose coordinates are numbers on the earth; null when either is missing or off it. */
export function pinOf(latitude, longitude) {
    if (typeof latitude !== 'number' || typeof longitude !== 'number')
        return null;
    if (!Number.isFinite(latitude) || !Number.isFinite(longitude))
        return null;
    if (latitude < -90 || latitude > 90 || longitude < -180 || longitude > 180)
        return null;
    return { latitude: degreesOf(microDegrees(latitude)), longitude: degreesOf(microDegrees(longitude)) };
}
/** Where to look at a pin — a link a person opens, not a service the store calls. */
export function pinLink(pin) {
    const lat = pin.latitude.toFixed(6);
    const lng = pin.longitude.toFixed(6);
    return `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=18/${lat}/${lng}`;
}
//# sourceMappingURL=geo.js.map